import * as net from '~/lib/net';
import * as schemas from '~/apps/shared/apis/schemas';
import { InfoEndpoints } from "~/apps/shared/apis/endpoints";
import { getToken } from "~/apps/shared/services/token";
import { InformationSettingsRequest } from "~/apps/shared/models";

export async function getInformationSettings(): Promise<InformationSettingsRequest> {
  const data = await net.apiGet(InfoEndpoints.settings(), getToken());
  return schemas.InformationSettingsSchema.load(data);
}
